import React, { useEffect, useState } from 'react'
import { FilesTable } from '../../components/Tables'
import Modal from '../../components/Modals/Modal'
import Loading from '../Loading'
import { useDispatch, useSelector } from 'react-redux'
import RegistroDocumentoModal from './RegistroDocumentoModal'
import ConfirmationAlert from '../../components/ConfirmationAlert'
import { specificConfigurationDataUrl } from '../../redux/apiUrl'
import { pdf } from '@react-pdf/renderer'
import FilePdf from '../../pdf/FilePdf'
import { saveAs } from "file-saver";
import { useParams } from 'react-router-dom'
import { createDocumento, getDocumentosByPatientId, deleteDocumento } from '../../redux/features/documentosSlice'
import { toast } from "react-hot-toast";
import { BiPlus } from 'react-icons/bi'
import { getVisitas } from '../../redux/features/visitasSlice'


const Documentos = (
  { data: patient }
) => {

  const { id: patient_id } = useParams();
  const dispatch = useDispatch();
  const [openDocumentosModal, setOpenDocumentosModal] = useState(false)
  const [doctorData, setDoctorData] = useState(null);

  const {
    data: documentosBypatient,
    isLoading: isLoadingDocumentos,
    error: errorDocumentos
  } = useSelector((state) => state.documentos);

  const visitas = useSelector((state) => state.visita.visitas);


  useEffect(() => {
    console.log(documentosBypatient)
  }, [documentosBypatient])

  useEffect(() => {
    if (patient_id) {
      dispatch(getDocumentosByPatientId(patient_id));
      dispatch(getVisitas(patient_id));
    }
  }, [patient_id, dispatch]);

  useEffect(() => {
    // useeffect para obtener los datos del doctor by Yamil

    const fetchDoctorData = async () => {
      try {
        const response = await fetch(specificConfigurationDataUrl);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del doctor");
        }
        const data = await response.json();
        setDoctorData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorData();
  }, []);

  const edadPatient = (fechaInicioStr, fechaFinStr) => {
    const fechaInicio = new Date(fechaInicioStr);
    const fechaFin = new Date(fechaFinStr);

    let anios = fechaFin.getFullYear() - fechaInicio.getFullYear();
    let meses = fechaFin.getMonth() - fechaInicio.getMonth();

    if (meses < 0) {
      anios -= 1;
      meses += 12;
    }

    return `${anios} Años, ${meses} Meses`;
  }

  const parseHtmlToReactPdfBlocks = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const output = [];

    doc.body.childNodes.forEach((node) => {
      if (node.nodeName === "P") {
        const fragments = [];
        node.childNodes.forEach((child) => {
          if (child.nodeType === 3) {
            fragments.push({ text: child.textContent });
          } else if (child.nodeName === "STRONG") {
            fragments.push({ text: child.textContent, bold: true });
          } else if (child.nodeName === "I") {
            fragments.push({ text: child.textContent, italic: true });
          } else {
            fragments.push({ text: child.textContent });
          }
        });
        output.push({ type: "paragraph", content: fragments });
      }

      if (node.nodeName === "UL") {
        const items = Array.from(node.querySelectorAll("li")).map((li) => ({
          text: `• ${li.textContent.trim()}`
        }));
        output.push({ type: "list", content: items });
      }

      if (node.nodeName === "OL") {
        const items = Array.from(node.querySelectorAll("li")).map((li, i) => ({
          text: `${i + 1}. ${li.textContent.trim()}`
        }));
        output.push({ type: "list", content: items });
      }
    });

    return output;
  };

  const printFile = async (contenido, nombre, tem_id) => {

    const fechaCorta = new Date().toISOString().split("T")[0];
    const fechaNacimiento = patient.persona.fecha_nacimiento.split("T")[0];
    const edad = edadPatient(fechaNacimiento, fechaCorta)

    const aux = parseHtmlToReactPdfBlocks(contenido)

    console.log(aux)

    ConfirmationAlert({
      title: "Imprimir Documento",
      text: "Esta seguro de imprimir este documento?",
      onAccept: async () => {
        const blob = await pdf(
          <FilePdf
            data={{
              id: tem_id,
              edad,
              contenido: aux,
              tipoDocumento: nombre,
              doctor: doctorData,
            }}
          />
        ).toBlob();
        saveAs(
          blob,
          `${nombre}-${new Date().toLocaleDateString("en-GB")}.pdf`
        );
      },
    });
  };

  const handleCloseModal = () => {
    setOpenDocumentosModal(false);
  };

  const handleSaveData = async (data) => {

    const { contenido_procesado, fecha, template_id } = data
    const aux = parseInt(patient_id)
    const newRegistro = {
      contenido: contenido_procesado,
      fecha,
      template_id,
      patient_id: aux
    }

    try {
      await dispatch(createDocumento(newRegistro)).unwrap();
      toast.success("Documento creado con éxito");
      dispatch(getDocumentosByPatientId(patient_id));
    } catch (error) {
      console.error("Error al crear documento:", error);
      toast.error(
        `Error al guardar el documento: ${error.message || JSON.stringify(error)}`
      );
    }
  }

  const handleDeleteData = async (id) => {
    ConfirmationAlert({
      title: "Eliminar Documento",
      text: "¿Está seguro que desea eliminar este documento? Esta acción no se puede deshacer.",
      onAccept: async () => {
        try {
          await dispatch(deleteDocumento(id)).unwrap();
          toast.success("Documento eliminado con éxito");
        } catch (error) {
          console.error("Error al eliminar documento:", error);
          toast.error(
            `Error al eliminar el documento: ${error.message || JSON.stringify(error)}`
          );
        }
      },
    });
  }

  if (isLoadingDocumentos) {
    return <Loading />;
  }

  if (errorDocumentos) {
    return (
      <div className="text-red-500 p-4">
        Error al cargar datos:{" "}
        {errorDocumentos?.message || "Error desconocido"}
      </div>
    );
  }

  return (
    <>
      <Modal
        isOpen={openDocumentosModal}
        closeModal={handleCloseModal}
        title="Generar Documento"
        width="max-w-3xl"
      >
        <RegistroDocumentoModal
          onSave={handleSaveData}
          onClose={handleCloseModal}
          data={visitas}
        />
      </Modal>
      {(!visitas || Object.keys(visitas).length === 0) ? (
        <div>
          El/La paciente {patient.persona.nombre} {patient.persona.apellidos} no tiene registro de visitas.
          Primero debe tener registrada una visita.
        </div>
      ) : (
        <>
          {(!documentosBypatient || Object.keys(documentosBypatient).length === 0) ? (
            <div>
              El/La paciente {patient.persona.nombre} {patient.persona.apellidos} no tiene historial de documentos.
            </div>
          ) : (
            <FilesTable
              data={documentosBypatient}
              functions={{
                delete: handleDeleteData,
                print: printFile,
              }}
            />
          )}
          <button
            className="w-10 animate-bounce h-10 border border-border z-40 bg-subMain text-white rounded-full flex-colo fixed bottom-5 right-5 button-fb hover:cursor-pointer"
            onClick={() => setOpenDocumentosModal(true)}
          >
            <BiPlus className="text-2xl" />
          </button>
        </>
      )}
    </>
  );
}


export default Documentos